// SECURITY NOTE: This module only forwards performance metrics to a caller-supplied callback (currently unused/no-op per index.js) and contains no network calls, user input handling, or credential logic of its own. If a reporting callback is ever wired up (e.g. sending vitals to an analytics endpoint), that endpoint should be reviewed separately for data exposure (avoid sending PII/session identifiers alongside perf metrics).
// ⚡ SEVERITY: ⚪ INFO - 0%
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
